import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { getCookie, removeFromCart, setCookie } from "../../utils/cookieUtils";
import Navbar from "../nav";
import Cartheading from "./Cartheading";
import axiosInstance from "../../utils/axiosInstance";

export default function Cartcomponents() {
  const [products, setProducts] = useState([]);
  const [cartItemsFromCookie, setCartItemsFromCookie] = useState([]);
  const [totalPrice, setTotalPrice] = useState(0); // New state for total price
  const navigate = useNavigate();

  const [insideSaurahaChecked, setInsideSaurahaChecked] = useState(false);
  const [outsideSaurahaChecked, setOutsideSaurahaChecked] = useState(false);


  // ...
  
  useEffect(() => {
    // Fetch product for each item in the cart
    const fetchProducts = async () => {
      // Check if cart items are available and not empty
      if (!cartItemsFromCookie || cartItemsFromCookie.length === 0) {
        return; // Cart items are not available yet or cart is empty
      }
  
      try {
        const productsData = [];
  
        // Loop through each cart item and fetch product details
        for (const item of cartItemsFromCookie) {
          const response = await axiosInstance.get(
            `/api/products/get-product/${item.productId}`
          );
  
          if (response.status === 200) {
            const productData = response.data;
            productsData.push(productData);
          } else {
            throw new Error(`HTTP error! Status: ${response.status}`);
          }
        }
  
        // Set the products in state
        setProducts(productsData);
  
        // Calculate total price and set the state
        const calculatedTotalPrice = productsData.reduce((total, item, index) => {
          const itemPrice = item.discountprice ? item.discountprice : item.price;
          const totalPriceForItem = itemPrice * cartItemsFromCookie[index].quantity;
          return total + totalPriceForItem;
        }, 0);
        
        setTotalPrice(calculatedTotalPrice);
        setCookie("totalprice", JSON.stringify(calculatedTotalPrice), 30); // 30 days expiration, adjust as needed
      } catch (error) {
        console.error("Error fetching product details:", error);
      }
    };
  
    fetchProducts();
  }, [cartItemsFromCookie, axiosInstance]); // Added axiosInstance to dependencies
  
  useEffect(() => {
    // Update cartItemsFromCookie state when the component mounts
    setCartItemsFromCookie(JSON.parse(getCookie("cartItems")) || []);
  }, []); // Empty dependency array to run only once when the component mounts

  const handleRemoveItemClick = (id) => {
    removeFromCart(id);
    // Add any additional logic you need
    window.location.reload();
  };

  const handleProceedToCheckout = () => {
    // Perform any necessary processing before navigating to checkout
    //  localStorage.setItem("totalprice",totalPrice)
    let updatedTotalPrice = totalPrice;  // Use a different name for the local variable
    if (insideSaurahaChecked) updatedTotalPrice += 50;
    if (outsideSaurahaChecked) updatedTotalPrice += 100;

    navigate('/checkout', { state: { totalPrice: updatedTotalPrice } });
  };

  return (
    <div>
      <Navbar />
      <div className="mt-20">
        <Cartheading />

        <div className="flex mx-6 flex-col justify-evenly md:flex-row">
          {/* Left side: Product Details */}
          <div className="flex-1">
            <h2 className=" mt-4 text-2xl font-semibold text-amber-600">Your Order</h2>
            {products.length === 0 ? (
              <p>Your cart is empty. 
                If you order something please visit to Your Profile

                
              </p>
            ) : (
              products.map((item, index) => (
                <div  key={item._id} className="flex border-b mt-4  border-gray-300 flex-col md:flex-row justify-around  p-2  mb-4">
                  {/* Product Image */}
                    <div className="flex  ">
                    <img
                    src={`${axiosInstance.defaults.baseURL}/${item.image}`}

                    alt={item.name}
                    className="w-24 h-24 object-cover"
                  />

                  {/* Product Price */}
                  <div className="ml-4 ">
                    <p>{item.name}</p>
                    {cartItemsFromCookie[index]?.cakeDetails && (
                      <>
                        <p className="font-semibold">
                          Message On Cake:{" "}
                          <span className="font-light">
                        {cartItemsFromCookie[
                            index
                          ].cakeDetails.messageOnCake?.toString()}
                        </span>
                        </p>
                        
                        <p className="font-semibold">
                          Add Egg:

                          <span className="font-normal">
                          {cartItemsFromCookie[
                            index
                          ].cakeDetails.addEgg?.toString()}
                          </span>
                         
                        </p>
                        <p className="font-semibold">
                        Make Sugarless:

                          <span className="font-normal">
                          {cartItemsFromCookie[
                            index
                          ].cakeDetails.makeSugarless?.toString()}
                          </span>
                         
                        </p>
                        
                      </>
                    )}
                   
                  </div>
                    </div>

                  <div >
                  <p className="text-lg font-bold">Quantity: </p>
                  <p>{cartItemsFromCookie[index].quantity}</p>

                  </div>
                  
                  <div>
                  <p className="text-lg font-bold">Sub Total: </p>
                  <p>NPR:{item.price}</p>
                  {item.discountprice && (

<span className="title-font font-medium text-lg text-red-500">
  {item.discountprice}
</span>
 )}

                  </div>

                  <div className="">
                  <button className="bg-red-500 p-1 text-white rounded" onClick={() => handleRemoveItemClick(item._id)}>
                      Remove cart
                    </button>
                  </div>
                  
                </div>
              ))
            )}
          </div>

          {/* Right side: Total and Checkout */}
          <div className="flex-3 lg:flex-3 p-4 bg-white  rounded-lg md:w-2/5">
        <p className="font-semibold text-2xl text-amber-600 mb-4">Cart Total</p>

  <div className="border-b border-gray-300 p-2">
    <p className="font-bold text-base text-gray-600">Subtotal</p>
    <p className="text-lg">NPR:{totalPrice}</p>
  </div>

  <div className="flex flex-col justify-between border-b border-gray-300 p-2">
    <p className="font-bold text-base text-gray-600">Shipping Total</p>
    <div className="flex items-center space-x-4 mt-2">
      <label className="flex items-center space-x-2">
        <input
          type="checkbox"
          checked={insideSaurahaChecked}
          onChange={() => setInsideSaurahaChecked(!insideSaurahaChecked)}
        />
        <span className="font-light text-gray-600">Inside Sauraha (+NPR 50)</span>
      </label>
      <label className="flex items-center space-x-2">
        <input
          type="checkbox"
          checked={outsideSaurahaChecked}
          onChange={() => setOutsideSaurahaChecked(!outsideSaurahaChecked)}
        />
        <span className="font-light text-gray-600">Outside Sauraha (+NPR 100)</span>
      </label>
    </div>
  </div>

  <div className="flex justify-between p-2">
    <p className="font-bold text-lg text-gray-600">Total Price</p>
    <p className="text-2xl text-red-500">NPR:{totalPrice}</p>
  </div>

  <div className="flex items-center justify-center mt-4">
  <button
  className="bg-gradient-to-r from-red-500 to-red-600 hover:from-red-600 hover:to-red-700 p-3 w-full text-white font-semibold rounded-md shadow-md transition duration-300 ease-in-out"
  onClick={handleProceedToCheckout}
>
  Proceed to Checkout (NPR {totalPrice})
</button>
  </div>
  <div className="p-6"></div>
</div>


        </div>
      </div>
    </div>
  );
}
